// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBlock_wrapper__1d0nz","message":"ErrorBlock_message__JS5cx"};